/**
 * ContactsAltIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ContactsAltIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M4.393 14.509a.9.9 0 0 1 0 1.79l-.092.005H3.5a1.6 1.6 0 0 0-1.6 1.6V19l-.004.093a.9.9 0 0 1-1.792 0L.1 19v-1.096a3.4 3.4 0 0 1 3.4-3.4h.8zm9.446-1.51a4.4 4.4 0 0 1 4.4 4.4V19a.9.9 0 0 1-1.8 0v-1.6a2.6 2.6 0 0 0-2.6-2.6H10.16a2.6 2.6 0 0 0-2.6 2.6V19a.9.9 0 0 1-1.8 0v-1.6a4.4 4.4 0 0 1 4.4-4.4zm6.661 1.505a3.4 3.4 0 0 1 3.4 3.4V19a.9.9 0 0 1-1.8 0v-1.096a1.6 1.6 0 0 0-1.6-1.6h-.8a.9.9 0 0 1 0-1.8z" />
    <path
      fillRule="evenodd"
      d="M2.68 8.784a2.923 2.923 0 0 1 4.025.103l.104.11a2.923 2.923 0 0 1 0 3.915l-.104.11a2.923 2.923 0 0 1-4.024.103l-.11-.104a2.923 2.923 0 0 1 0-4.134zm2.753 1.376a1.124 1.124 0 0 0-1.503-.077l-.086.077a1.124 1.124 0 0 0 0 1.589l.086.077c.44.36 1.092.334 1.503-.077l.077-.086a1.124 1.124 0 0 0 0-1.417zm11.971-1.376a2.923 2.923 0 0 1 4.025.103l.103.11a2.923 2.923 0 0 1 0 3.915l-.103.11a2.923 2.923 0 0 1-4.025.103l-.11-.104a2.924 2.924 0 0 1 0-4.134zm2.752 1.376a1.124 1.124 0 0 0-1.503-.077l-.086.077a1.124 1.124 0 0 0 0 1.589l.086.077c.441.36 1.092.333 1.503-.077l.077-.086a1.124 1.124 0 0 0 0-1.417zM9.31 5.134a4.015 4.015 0 0 1 5.529.142l.142.15a4.016 4.016 0 0 1 0 5.378l-.142.15a4.015 4.015 0 0 1-5.528.142l-.15-.142a4.015 4.015 0 0 1 0-5.678zm4.256 1.415a2.216 2.216 0 0 0-2.964-.153l-.168.153a2.216 2.216 0 0 0 0 3.132l.168.152c.87.71 2.153.66 2.964-.152l.152-.169a2.216 2.216 0 0 0 0-2.795z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ContactsAltIcon = makeIcon('ContactsAltIcon', ContactsAltIconSvg)
